import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { MapPin, Phone, Mail, Clock, CheckCircle } from 'lucide-react';
export function ContactPage() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
  };
  return <main className="pt-20 pb-20 bg-gray-50" data-id="element-341">
      <div className="bg-white py-16 mb-12 shadow-sm" data-id="element-342">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-343">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-344">
            Get in Touch
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-345">
            Have questions? We're here to help! Reach out to us via phone,
            email, or visit us in person.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-346">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-347">
          {/* Contact Info */}
          <div className="lg:col-span-1 space-y-6" data-id="element-348">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-349">
              <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-350">
                Contact Information
              </h3>
              <div className="space-y-6" data-id="element-351">
                <div className="flex items-start" data-id="element-352">
                  <MapPin className="w-6 h-6 text-primary mr-4 mt-1" data-id="element-353" />
                  <div data-id="element-354">
                    <p className="font-semibold text-gray-900" data-id="element-355">Address</p>
                    <p className="text-gray-600" data-id="element-356">
                      1363 S. Old US 23
                      <br data-id="element-357" />
                      Brighton, Michigan 48114
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-358">
                  <Phone className="w-6 h-6 text-primary mr-4 mt-1" data-id="element-359" />
                  <div data-id="element-360">
                    <p className="font-semibold text-gray-900" data-id="element-361">Phone</p>
                    <a href="tel:8107753153" className="text-gray-600 hover:text-primary transition-colors" data-id="element-362">
                      (810) 775-3153
                    </a>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-363">
                  <Mail className="w-6 h-6 text-primary mr-4 mt-1" data-id="element-364" />
                  <div data-id="element-365">
                    <p className="font-semibold text-gray-900" data-id="element-366">Email</p>
                    <a href="mailto:info@limitlesstaekwondo.com" className="text-gray-600 hover:text-primary transition-colors" data-id="element-367">
                      info@limitlesstaekwondo.com
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-368">
              <div className="flex items-center mb-6" data-id="element-369">
                <Clock className="w-6 h-6 text-primary mr-3" data-id="element-370" />
                <h3 className="text-xl font-bold text-gray-900" data-id="element-371">Class Hours</h3>
              </div>
              <ul className="space-y-3 text-gray-600" data-id="element-372">
                <li className="flex justify-between border-b border-gray-100 pb-2" data-id="element-373">
                  <span data-id="element-374">Mon - Thu</span>
                  <span className="font-medium" data-id="element-375">4:00 PM - 8:30 PM</span>
                </li>
                <li className="flex justify-between border-b border-gray-100 pb-2" data-id="element-376">
                  <span data-id="element-377">Friday</span>
                  <span className="font-medium" data-id="element-378">4:00 PM - 7:30 PM</span>
                </li>
                <li className="flex justify-between border-b border-gray-100 pb-2" data-id="element-379">
                  <span data-id="element-380">Saturday</span>
                  <span className="font-medium" data-id="element-381">9:00 AM - 12:00 PM</span>
                </li>
                <li className="flex justify-between" data-id="element-382">
                  <span data-id="element-383">Sunday</span>
                  <span className="font-medium" data-id="element-384">Closed</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact Form */}
          <div className="lg:col-span-2" data-id="element-385">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100" data-id="element-386">
              {isSubmitted ? <div className="text-center py-12" data-id="element-387">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-388">
                    <CheckCircle className="w-8 h-8 text-green-600" data-id="element-389" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-390">
                    Message Sent!
                  </h3>
                  <p className="text-gray-600" data-id="element-391">
                    Thank you for contacting us. We will get back to you as soon
                    as possible.
                  </p>
                </div> : <>
                  <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-392">
                    Send us a Message
                  </h3>
                  <form onSubmit={handleSubmit} className="space-y-6" data-id="element-393">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-394">
                      <Input label="First Name" placeholder="John" required data-id="element-395" />
                      <Input label="Last Name" placeholder="Doe" required data-id="element-396" />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-397">
                      <Input label="Email" type="email" placeholder="john@example.com" required data-id="element-398" />
                      <Input label="Phone" type="tel" placeholder="(555) 555-5555" required data-id="element-399" />
                    </div>
                    <div data-id="element-400">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-401">
                        Message
                      </label>
                      <textarea className="w-full rounded-md border border-gray-300 p-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent h-32" placeholder="How can we help you?" required data-id="element-402"></textarea>
                    </div>
                    <Button type="submit" size="lg" data-id="element-403">
                      Send Message
                    </Button>
                  </form>
                </>}
            </div>

            {/* Map Placeholder */}
            <div className="mt-8 bg-gray-200 rounded-xl h-64 w-full flex items-center justify-center overflow-hidden relative" data-id="element-404">
              <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1524661135-423995f22d0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80')] bg-cover bg-center opacity-50" data-id="element-405"></div>
              <div className="relative z-10 bg-white/90 backdrop-blur px-6 py-3 rounded-lg shadow-lg text-center" data-id="element-406">
                <MapPin className="w-8 h-8 text-primary mx-auto mb-2" data-id="element-407" />
                <p className="font-bold text-gray-900" data-id="element-408">1363 S. Old US 23</p>
                <p className="text-sm text-gray-600" data-id="element-409">Brighton, MI 48114</p>
                <a href="https://maps.google.com/?q=1363+S+Old+US+23+Brighton+MI+48114" target="_blank" rel="noopener noreferrer" className="text-primary text-sm font-medium hover:underline mt-2 inline-block" data-id="element-410">
                  Get Directions
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>;
}